




























import { Component , Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import '../assets/css/SessionTimeout.scss';
@Component({})
export default class SessionTimeout extends Vue {
    private show = true;
    private timeCounter: number = 60;
    private timerId: any = undefined;

    private mounted() {
        this.timeCounter = 60;
        this.timerId = setInterval(() => {
            this.timeCounter--;
            if (this.timeCounter < 1) {
                clearInterval(this.timerId);
                this.$emit('logout');
            }
        }, 1000);
        document.onmousemove = () => {
            this.continueSession();
        };
    }

    private async continueSession() {
        clearInterval(this.timerId);
        this.$emit('close');
    }

    private logout() {
        ObjectFactory.getCacheService().clearCache();
        ObjectFactory.getCacheService().saveSessionValue(MedTransGoConstants.FIELD_STATE, location.pathname);
        const uncService = ObjectFactory.getUNCService();
        if (uncService.isUNCSubdomain()) {
            location.href = '/';
        } else {
            // Regular login
            const redirectUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
            location.href = redirectUrl;
        }
    }
}
